import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Actions from 'components/actions/Actions'
import { ICON_FACEBOOK, ICON_MESSENGER } from 'components/common/Icon'

const MatchActions = props => {
  const { onFacebook, onMessenger } = props

  return (
    <Div width="50%" display="flex">
      <Actions
        actions={[
          { key: 'facebook', icon: ICON_FACEBOOK, onClick: onFacebook },
          { key: 'messenger', icon: ICON_MESSENGER, onClick: onMessenger }
        ]}
      />
    </Div>
  )
}

MatchActions.propTypes = {
  onFacebook: PropTypes.func.isRequired,
  onMessenger: PropTypes.func.isRequired
}

export default MatchActions



// WEBPACK FOOTER //
// ./src/components/actions/MatchActions.js